import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DataFlightService } from 'src/app/services';

@Component({
  selector: 'app-wallet-payment',
  templateUrl: './wallet-payment.component.html',
  styleUrls: ['./wallet-payment.component.scss']
})
export class WalletPaymentComponent implements OnInit {
  @Input() item: any;
  WALLETS_FORM!: FormGroup;
  WALLETS_LIST: any[] = [];
  selectedWallet: string = '';
  selectedWalletItem: any = null;
  wallet_banking: any = null;
  term: string = '';
  constructor(private fb: FormBuilder, private DATA_FLIGHT: DataFlightService) { }

  ngOnInit(): void {
    // console.log('Initial item wallet-payment:', this.item);
    this.WALLETS_LIST = this.item?.options?.map(i => ({
      ...i, logo: this.DATA_FLIGHT.getBankIcon(i.name)
    })) || [];

    this.WALLETS_FORM = this.fb.group({
      wallets_banking_value: ['', Validators.required]
    });
    
  }

  selectWalletBanking(item: any): void {
    this.selectedWallet = item.name;
    this.WALLETS_FORM.get('wallets_banking_value')?.setValue(item);
  }

  onRadiowalletChange(event:any): void{
    this.selectedWallet = event.value.name;
    this.wallet_banking = event.value;
  }

  getWALLETSPAYMENTFormValue(): any {
    if (this.WALLETS_FORM.invalid) {
      this.WALLETS_FORM.markAllAsTouched();
      return null;
    }
    return this.WALLETS_FORM.value;
  }
}
